import _classCallCheck from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component, PropTypes } from 'react';
import styles from '../../build/styles';
import { getCallbacks } from '../helper/helper';

var Addons =
/*#__PURE__*/
function (_Component) {
  _inherits(Addons, _Component);

  function Addons() {
    _classCallCheck(this, Addons);

    return _possibleConstructorReturn(this, _getPrototypeOf(Addons).apply(this, arguments));
  }

  _createClass(Addons, [{
    key: "createControlClassName",
    value: function createControlClassName() {
      return [styles.control, styles.hasAddons, this.props.className, this.props.hasAddonsCentered ? styles.hasAddonsCentered : '', this.props.hasAddonsRight ? styles.hasAddonsRight : ''].join(' ').trim();
    }
  }, {
    key: "cloneWithProps",
    value: function cloneWithProps() {
      var _this = this;

      if (React.Children.count(this.props.children) === 1) {
        return this.props.children && React.cloneElement(this.props.children, {
          color: this.props.color,
          hasAddons: true
        });
      }

      return this.props.children.map(function (child, i) {
        return React.cloneElement(child, {
          color: _this.props.color,
          key: i,
          hasAddons: true
        });
      });
    }
  }, {
    key: "renderHelp",
    value: function renderHelp() {
      if (!this.props.help) return null;
      return React.createElement('span', {
        className: [styles.help, styles[this.props.help.color]].join(' ')
      }, this.props.help.text);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement('span', null, React.createElement('p', _extends({
        className: this.createControlClassName(),
        style: this.props.style
      }, getCallbacks(this.props)), this.props.children && this.cloneWithProps()), this.renderHelp());
    }
  }]);

  return Addons;
}(Component);

export { Addons as default };
Addons.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.any,
  color: PropTypes.oneOf(['isPrimary', 'isInfo', 'isSuccess', 'isWarning', 'isDanger', 'isLink', 'isWhite', 'isLight', 'isDark', 'isBlack', 'isLink']),
  help: PropTypes.shape({
    text: PropTypes.string,
    color: PropTypes.oneOf(['isPrimary', 'isInfo', 'isSuccess', 'isWarning', 'isDanger'])
  }),
  hasAddonsCentered: PropTypes.bool,
  hasAddonsRight: PropTypes.bool
};
Addons.defaultProps = {
  style: {},
  className: ''
};